import { z } from 'zod';
import { TransformSucceededDetails } from 'libs/end-to-end/src/types/databases/transform/transform-succeeded-details';
import { TransformFailedDetails } from 'libs/end-to-end/src/types/databases/transform/transform-failed-details';
import { TransformRunningDetails } from 'libs/end-to-end/src/types/databases/transform/transform-running-details';
import { TransformNotStartedDetails } from 'libs/end-to-end/src/types/databases/transform/transform-not-started-details';

export const TransformDetails = z.union([
  TransformSucceededDetails,
  TransformFailedDetails,
  TransformRunningDetails,
  TransformNotStartedDetails,
]);

export type TransformDetails = z.infer<typeof TransformDetails>;
